import {
    COLLEGE_CORNER_FETCH_COLLEGE_PLAYERS,
    COLLEGE_CORNER_FETCH_COLLEGE_PLAYERS_FAILURE,
    COLLEGE_CORNER_FETCH_COLLEGE_PLAYERS_SUCCESS,
    COLLEGE_CORNER_FETCH_COLLEGE_RANKINGS,
    COLLEGE_CORNER_FETCH_COLLEGE_RANKINGS_FAILURE,
    COLLEGE_CORNER_FETCH_COLLEGE_RANKINGS_SNAPSHOT,
    COLLEGE_CORNER_FETCH_COLLEGE_RANKINGS_SNAPSHOT_FAILURE,
    COLLEGE_CORNER_FETCH_COLLEGE_RANKINGS_SNAPSHOT_SUCCESS,
    COLLEGE_CORNER_FETCH_COLLEGE_RANKINGS_SUCCESS,
    COLLEGE_CORNER_FETCH_COLLEGE_TEAMS,
    COLLEGE_CORNER_FETCH_COLLEGE_TEAMS_FAILURE,
    COLLEGE_CORNER_FETCH_COLLEGE_TEAMS_SUCCESS,
    COLLEGE_CORNER_FETCH_JUNIOR_PROSPECTS,
    COLLEGE_CORNER_FETCH_JUNIOR_PROSPECTS_FAILURE,
    COLLEGE_CORNER_FETCH_JUNIOR_PROSPECTS_SUCCESS,
    COLLEGE_CORNER_FETCH_COMMON_DATA,
    COLLEGE_CORNER_FETCH_COMMON_DATA_FAILURE,
    COLLEGE_CORNER_FETCH_COMMON_DATA_SUCCESS,
} from './actionTypes/college-corner-action-types';
import { RECRUITING_STATUS_FILTER } from '../pages/CollegeCorner/pages/CollegeCornerJuniorProspects/cppConstants';

export const fetchCollegeCornerDataCommonAPI = (api) => async (
    dispatch,
    getState,
    { mainApi },
) => {
    dispatch({ type: COLLEGE_CORNER_FETCH_COMMON_DATA });
    try {
        const res = await mainApi.get(`/v2/search${api}`);
        const { data } = res;
        const { hits } = data;
        dispatch({ type: COLLEGE_CORNER_FETCH_COMMON_DATA_SUCCESS });
        return Array.isArray(hits) && hits.length ? hits : [];
    } catch (error) {
        dispatch({ type: COLLEGE_CORNER_FETCH_COMMON_DATA_FAILURE });
        return false;
    }
};

export const queryCollegeTeamsAPI = (params) => async (
    dispatch,
    getState,
    { mainApi },
) => {
    dispatch({ type: COLLEGE_CORNER_FETCH_COLLEGE_TEAMS });
    try {
        const {
            limit,
            order,
            sort,
            page,
            gender,
            conference,
            division,
            distance,
            lat,
            lng,
        } = params;
        let queryString = '';
        if (gender) {
            queryString += `&gender=${gender}`;
        }
        if (conference) {
            queryString += `&conferenceId=${conference}`;
        }
        if (division) {
            queryString += `&divisionId=${division}`;
        }
        if (distance && lat && lng) {
            queryString += `&distance=${distance}`;
        }
        if (lat && lng) {
            queryString += `&pin=${lat},${lng}`;
        }

        const res = await mainApi.get(
            `/v2/search/colleges?top=${limit}&skip=${(page - 1) *
            10}&utrType=verified&utrTeamType=singles&schoolClubSearch=true&sort=${sort}%3A${order}&searchOrigin=searchPage${queryString}`,
        );
        const { data } = res;
        const { total = 0, totalAllowed = 0, hits = [] } = data;
        dispatch({ type: COLLEGE_CORNER_FETCH_COLLEGE_TEAMS_SUCCESS });
        return Array.isArray(hits) && hits.length
            ? { rows: hits, count: total > totalAllowed ? totalAllowed : total }
            : { rows: [], count: 0 };
    } catch (error) {
        dispatch({ type: COLLEGE_CORNER_FETCH_COLLEGE_TEAMS_FAILURE });
        return false;
    }
};

export const queryCppCollegeTeamsAPI = (params) => async (
    dispatch,
    getState,
    { mainApi },
) => {
    dispatch({ type: COLLEGE_CORNER_FETCH_COLLEGE_TEAMS });
    try {
        const {
            limit,
            order,
            sort,
            page,
            gender,
            conference,
            division,
            distance,
            lat,
            lng,
            utrFitRating,
            utrFitPosition,
        } = params;
        let queryString = '';
        if (gender) {
            queryString += `&gender=${gender}`;
        }
        if (conference) {
            queryString += `&conferenceId=${conference}`;
        }
        if (division) {
            queryString += `&divisionId=${division}`;
        }
        if (lat && lng) {
            queryString += `&lat=${lat}&lng=${lng}`;
            if (distance) {
                queryString += `&distance=${parseInt(distance, 10)}`;
            }
        }
        if (utrFitRating) {
            queryString += `&utrFitRating=${utrFitRating}&utrFitPosition=${utrFitPosition || 1}`;
        }

        const res = await mainApi.get(
            `/v1/cpp/college-corner/college-teams?top=${limit}&skip=${(page - 1) *
            limit}&sort=${sort}&order=${order}${queryString}`,
        );
        const { data } = res;
        const { total = 0, results = [] } = data;
        dispatch({ type: COLLEGE_CORNER_FETCH_COLLEGE_TEAMS_SUCCESS });
        return Array.isArray(results) && results.length
            ? { rows: results, count: total }
            : { rows: [], count: 0 };
    } catch (error) {
        dispatch({ type: COLLEGE_CORNER_FETCH_COLLEGE_TEAMS_FAILURE });
        return false;
    }
};

export const queryCppJuniorProspectsAPI = (params) => async (
    dispatch,
    getState,
    { mainApi },
) => {
    dispatch({ type: COLLEGE_CORNER_FETCH_JUNIOR_PROSPECTS });
    try {
        const {
            limit,
            pageSize,
            order,
            sort,
            page,
            query,
            gender,
            utrMin,
            utrMax,
            utrType,
            utrTeamType,
            hsGradYears,
            nationality,
            recruitingStatus,
            distance,
            lat,
            lng,
        } = params;
        let queryString = '';
        if (query) {
            queryString += `&query=${encodeURIComponent(query)}`;
        }
        if (gender) {
            queryString += `&gender=${gender}`;
        }
        if (utrMin) {
            queryString += `&utrMin=${utrMin}`;
        }
        if (utrMax) {
            queryString += `&utrMax=${utrMax}`;
        }
        if (utrType) {
            queryString += `&utrType=${utrType}`;
        }
        if (utrTeamType) {
            queryString += `&teamType=${utrTeamType}`;
        }
        if (hsGradYears && Object.entries(hsGradYears).length) {
            Object.entries(hsGradYears).forEach(([year, isSelected]) => {
                if (year && isSelected) {
                    queryString += `&gradYearHs=${year}`;
                }
            });
        }
        if (nationality) {
            queryString += `&nationality=${nationality}`;
        }
        if (recruitingStatus && recruitingStatus !== RECRUITING_STATUS_FILTER.ALL) {
            queryString += `&recruitingStatus=${recruitingStatus}`;
        }
        if (lat && lng) {
            queryString += `&pin=${lat},${lng}`;
            if (distance) {
                queryString += `&distance=${distance}`;
            }
        }

        const res = await mainApi.get(
            `/v1/cpp/college-corner/prospects?page=${page}&pageSize=${pageSize || limit}&sort=${sort}&order=${order}${queryString}`,
        );
        const { data } = res;
        const { total = 0, hits = [] } = data;
        dispatch({ type: COLLEGE_CORNER_FETCH_JUNIOR_PROSPECTS_SUCCESS });
        return Array.isArray(hits) && hits.length
            ? { rows: hits, count: total }
            : { rows: [], count: 0 };
    } catch (error) {
        dispatch({ type: COLLEGE_CORNER_FETCH_JUNIOR_PROSPECTS_FAILURE });
        return false;
    }
};

export const addTargetCollegeAPI = (clubId) => async (
    dispatch,
    getState,
    { mainApi },
) => {
    const res = await mainApi.post('/v1/cpp/target-colleges', { clubId });
    return res;
};

export const addRecruitAPI = (targetMemberId) => async (
    dispatch,
    getState,
    { mainApi },
) => {
    const res = await mainApi.post('/v1/cpp/recruits', { targetMemberId });
    return res;
};

export const queryCollegePlayersAPI = (params, type = 'College') => async (
    dispatch,
    getState,
    { mainApi },
) => {
    dispatch({ type: COLLEGE_CORNER_FETCH_COLLEGE_PLAYERS });
    try {
        const {
            limit,
            order,
            sort,
            page,
            gender,
            conference,
            division,
            utrMin,
            utrMax,
            utrType,
            utrTeamType,
            utrReliability,
            hsGradYears,
            distance,
            lat,
            lng,
            nationality,
        } = params;
        let queryString = '';
        if (gender) {
            queryString += `&gender=${gender}`;
        }
        if (utrMin) {
            queryString += `&utrMin=${utrMin}`;
        }
        if (utrMax) {
            queryString += `&utrMax=${utrMax}`;
        }
        if (utrType) {
            queryString += `&utrType=${utrType}`;
        }
        if (utrTeamType) {
            queryString += `&utrTeamType=${utrTeamType}`;
        }
        if (utrReliability) {
            if (utrReliability && Object.entries(utrReliability).length) {
                Object.entries(utrReliability).forEach(([val, bool]) => {
                    if (val && bool) {
                        queryString += `&utrReliability=${val}`;
                    }
                });
            }
        }
        if (hsGradYears) {
            if (hsGradYears && Object.entries(hsGradYears).length) {
                Object.entries(hsGradYears).forEach(([year, bool]) => {
                    if (year && bool) {
                        queryString += `&gradYearHs=${year}`;
                    }
                });
            }
        }
        if (conference) {
            queryString += `&conferenceId=${conference}`;
        }
        if (division) {
            queryString += `&divisionId=${division}`;
        }
        if (nationality) {
            queryString += `&nationality=${nationality}`;
        }
        if (distance && lat && lng) {
            queryString += `&distance=${distance}`;
        }
        if (lat && lng) {
            queryString += `&pin=${lat},${lng}`;
        }

        // temp conditions for the time being untill reason for players API gives proper responses by neeraj
        if (type === 'Junior') {
            queryString += `&ageMin=${12}`;
        }
        if (type === 'Junior') {
            queryString += `&ageMax=${18}`;
        }
        const res = await mainApi.get(
            `/v2/search/players?top=${limit}&skip=${(page - 1) * 10}${type === 'Junior'
                ? `&primaryTags=Junior`
                : `&primaryTags=College`
            }&sort=${sort}%3A${order}&searchOrigin=searchPage${queryString}`,
        );
        const { data } = res;
        const { total = 0, totalAllowed = 0, hits = [] } = data;
        dispatch({ type: COLLEGE_CORNER_FETCH_COLLEGE_PLAYERS_SUCCESS });
        return Array.isArray(hits) && hits.length
            ? { rows: hits, count: total > totalAllowed ? totalAllowed : total }
            : { rows: [], count: 0 };
    } catch (error) {
        dispatch({ type: COLLEGE_CORNER_FETCH_COLLEGE_PLAYERS_FAILURE });
        return false;
    }
};

export const queryCollegeRankingsAPI = (params) => async (
    dispatch,
    getState,
    { mainApi },
) => {
    try {
        dispatch({ type: COLLEGE_CORNER_FETCH_COLLEGE_RANKINGS });
        const {
            gender,
            division,
            snapshotDate,
            order,
        } = params;

        let queryString = '';
        if (!division) {
            return false;
        }
        if (snapshotDate) {
            queryString += `&snapshotDateLabel=${snapshotDate}`;
        }

        if (order !== 'desc') {
            queryString += `&descending=${true}`;
        } else {
            queryString += `&descending=${false}`;
        }

        const res = await mainApi.get(
            `/v1/club/team-rating/top?divisionName=${division}&gender=${gender}${queryString}`,
        );
        const { data } = res;
        dispatch({ type: COLLEGE_CORNER_FETCH_COLLEGE_RANKINGS_SUCCESS });
        return data;
    } catch (error) {
        dispatch({ type: COLLEGE_CORNER_FETCH_COLLEGE_RANKINGS_FAILURE });
        return false;
    }
};

export const queryCollegeRankingsSnapshotAPI = () => async (
    dispatch,
    getState,
    { mainApi },
) => {
    dispatch({ type: COLLEGE_CORNER_FETCH_COLLEGE_RANKINGS_SNAPSHOT });
    try {
        const res = await mainApi.get(
            '/v1/club/team-rating/division/snapshot-date',
        );
        const { data } = res;
        dispatch({ type: COLLEGE_CORNER_FETCH_COLLEGE_RANKINGS_SNAPSHOT_SUCCESS });
        return data;
    } catch (error) {
        dispatch({ type: COLLEGE_CORNER_FETCH_COLLEGE_RANKINGS_SNAPSHOT_FAILURE });
        return false;
    }
};
